import jwtAuthKioskAxios from "../auth/jwtAuthKiosk";
import { setBackendDomain } from "./management";

// Resolve backend base for token validation in prod/staging without relying on dsokSettings
const getBaseUrlFromToken = (token) => {
  try {
    const part = token.split(".")[1] || "";
    const base64 = part.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64 + "===".slice((base64.length + 3) % 4);
    const payload = JSON.parse(atob(padded));
    const iss = payload?.iss || "";
    if (
      iss === "smolkoland.ikelp.com" ||
      iss === "skusit.ikelp.com" ||
      iss === "intesso.ikelp.com"
    ) {
      return "https://staging.gastrokiosk.online";
    }
    return "https://be.gastrokiosk.online";
  } catch (e) {
    return process.env.REACT_APP_BE_URL;
  }
};

export const validateToken = async (token) => {
  const env = (process.env.REACT_APP_ENVIRONMENT || "").trim();
  if (env === "prod" || env === "staging") {
    jwtAuthKioskAxios.defaults.baseURL = `${getBaseUrlFromToken(token)}/`;
  } else {
    setBackendDomain(jwtAuthKioskAxios);
  }
  const { data } = await jwtAuthKioskAxios.post("/partner/validateToken", {
    token,
  });
  if (data?.customer?.dsokSettings) {
    localStorage.setItem(
      "dsokSettings",
      JSON.stringify(data?.customer?.dsokSettings)
    );
  }
  return data;
};

export const getCustomer = async (token) => {
  setBackendDomain(jwtAuthKioskAxios);
  const { data } = await jwtAuthKioskAxios.get("/partner/customer", {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data.data;
};

export const getDeviceStatus = async (deviceId, customerUrl, token) => {
  setBackendDomain(jwtAuthKioskAxios);
  const { data } = await jwtAuthKioskAxios.get(`/partner/deviceStatus`, {
    params: { deviceId, customerUrl },
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};

export const updateCustomer = async (dsok, token) => {
  setBackendDomain(jwtAuthKioskAxios);
  const { data } = await jwtAuthKioskAxios.put(`/partner/customer`, dsok, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data?.result;
};

export const getOrderList = async (token) => {
  setBackendDomain(jwtAuthKioskAxios);
  const { data } = await jwtAuthKioskAxios.get(`/partner/order`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  return data.data;
};

export const getOrder = async (id, token) => {
  setBackendDomain(jwtAuthKioskAxios);
  const { data } = await jwtAuthKioskAxios.get(`/partner/order/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  return data.data?.length && data.data[0];
};

export const sendEkasaRegister = async (id, token) => {
  setBackendDomain(jwtAuthKioskAxios);
  const { data } = await jwtAuthKioskAxios.post(
    "/partner/order/ekasa-register",
    { id },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return data?.result;
};
